var CompactHeader = require("app/ui/header/CompactHeader"),
    kind          = require("enyo/kind");

module.exports = kind(/** @lends  app.ProductCategoryPage.CompactHeader.prototype */ {

    /**
     * @private
     */
    name: "app.ProductCategoryPage.CompactHeader",

    /**
     * @private
     */
    kind: CompactHeader,

    /**
     * @private
     */
    classes: "app-product-category-page-compact-header",

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.observe("app.$.authService.isLoggedIn", this.update);
        };
    }),

    /**
     * @method
     * @private
     */
    update: kind.inherit(function(sup) {
        return function() {
            this.$.playMediaButton.hide();

            sup.apply(this, arguments);
        };
    })
});
